import React, { useEffect, useRef, useState } from "react";
import { TbGalaxy } from "react-icons/tb";
import { useParams } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import InvoiceEmail from "./InvoiceEmail";

const Invoice = () => {
    const user_id = sessionStorage.getItem("user_id");
    const { inv_id } = useParams();
    const invoiceRef = useRef();
    const [openEmailModal, setOpenEmailModal] = useState(false)

    const [billingData, setBillingData] = useState(null);
    const [paymentData, setPaymentData] = useState([]);
    const [invoiceSummary, setInvoiceSummary] = useState({});
    const [issueDate, setIssueDate] = useState(null);
    const [dueDate, setDueDate] = useState(null);


    const [cardModal, openCardModal] = useState(false);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false)

    useEffect(() => {
        if (!user_id) {
            setLoading(false);
            return;
        }
        fetchInvoice();
        if (inv_id) {
        document.title = `Erioon invoice - ${inv_id}`;
    }
    }, [user_id, inv_id]);

    const fetchInvoice = async () => {
        setLoading(true);
        try {
            const response = await fetch("https://backend.erioon.com/get_invoice", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, inv_id }),
            });

            if (!response.ok) throw new Error("Failed to fetch billing info");

            const data = await response.json();

            setBillingData(data.payment_method || null);
            setPaymentData(data.matching_records || []);
            setInvoiceSummary(data.summary || {});
            if (data.matching_records && data.matching_records.length > 0) {
                const firstRecord = data.matching_records[0];
                setIssueDate(firstRecord.issue_date);
                setDueDate(firstRecord.due_date);
            }
        } catch (error) {
            setBillingData(null);
            setError(true);
        } finally {
            setLoading(false);
        }
    };



    const handleDownload = () => {
        const input = invoiceRef.current;
        html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "pt", "a4");
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            pdf.save(`invoice-${inv_id || "download"}.pdf`);

        });
    };

    const formatCurrency = (amount) => {
        return `$${(amount || 0).toFixed(2)}`;
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return isNaN(date) ? "N/A" : date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    };


    return (
        <div className="invoice_main">
            <div className="entire_invoice" >
                <div className="invoice_box" ref={invoiceRef}>
                    <div className="invoice_header">
                        <p className="invoice_title">Invoice</p>
                        <div className="invoice_logo">
                            <p className="sidebar_logo"><TbGalaxy /> Erioon</p>
                        </div>
                    </div>

                    <div className="invoice_info">
                        <p>Invoice number: <strong>{inv_id}</strong></p>
                        <p>Date of issue: <strong>{formatDate(issueDate)}</strong></p>
                        <p>Date of due: <strong>{formatDate(dueDate)}</strong></p>
                    </div>

                    <div className="billing_info">
                        <div className="billing_info_erioon">
                            <div>
                                <p>Erioon Srl</p>
                                <p>Via Emilio Gola, 5</p>
                                <p>20143 Milano, Milano, Italy</p>
                            </div>
                        </div>

                        <div className="billing_info_item">
                            <div className="bill_to">
                                <p><strong>Billed to:</strong></p>
                                <p>{billingData?.name} {billingData?.surname}</p>
                                <p>{billingData?.street}</p>
                                <p>{billingData?.postal_code}, {billingData?.city}, {billingData?.state}</p>
                            </div>
                        </div>
                    </div>

                    <p className="due_message">
                        {formatCurrency(invoiceSummary.total_amount)} due {formatDate(new Date())}
                    </p>

                    <table>
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Price ($)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paymentData.map((entry, idx) => (
                                <React.Fragment key={idx}>
                                    <tr>
                                        <td>Database Erioon-{entry.plan || "plan"} - {entry.db_id}</td>
                                        <td>{formatCurrency(entry.db_price)}</td>
                                    </tr>
                                    {entry.total_add_on_cost > 0 && (
                                        <tr>
                                            <td>&nbsp;&nbsp;&nbsp;Add ons - Db Operations ({entry.db_id})</td>
                                            <td>{formatCurrency(entry.total_add_on_cost)}</td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                            <tr>
                                <td>Tax</td>
                                <td>{formatCurrency(0)}</td>
                            </tr>
                            <tr>
                                <td className="total">Total</td>
                                <td className="total">{formatCurrency(invoiceSummary.total_amount)}</td>
                            </tr>
                        </tbody>
                    </table>


                    <p>
                        <strong>Payment Instructions:</strong> <br />
                        {billingData?.payment_method_id
                            ? "Your account has a credit card on file and there is no action for you to take. The card you have on file will be charged."
                            : "Please update your payment method to complete this transaction."}
                    </p>
                    <div className="payment_method">
                        <p><strong>Payment Method:</strong></p>
                        <p>{billingData?.additional_info} - {billingData?.card_details?.brand?.toUpperCase()} **** {billingData?.card_details?.last4}</p>
                        <p>Expires: {billingData?.card_details?.exp_month}/{billingData?.card_details?.exp_year}</p>
                    </div>
                </div>
                <div className="footer_invoice">
                    <p>
                        Visit
                        <a href="https://www.erioon.com/pricing"> Erioon Pricing</a> to learn more.
                    </p>
                </div>
            </div>

            <div className="sidebar_action_invoice">
                <button className="download_invoice" onClick={handleDownload}>
                    <i className="fa-solid fa-download"></i>
                </button>
                {/* <button className="download_invoice" onClick={() => setOpenEmailModal(true)}>
                    <i className="fa-solid fa-envelope"></i>
                </button> */}
            </div>
            <InvoiceEmail show={openEmailModal} handleClose={() => setOpenEmailModal(false)} />

        </div>
    );
};

export default Invoice;
